import Airtable from "airtable";
import moment from "moment";

const AIRTABLE_KEY =
  "pat69Vl5oBBDQFYMp.919cea754bdd33bd1a8c9c8a7c9f4aeba06562def440e209b44acbabdc87ddee";
const AIRTABLE_BASE = "appRyDpw6P4HZIdqT";
const AIRTABLE_MEAL_TABLE = "Meals";

Airtable.configure({ apiKey: AIRTABLE_KEY });
const base = Airtable.base(AIRTABLE_BASE);

export interface Meal {
  id: string;
  name: string;
  whoChoseIt: string;
  whoIsMakingIt?: string;
}

export type MealFields = {
  "Meal Name": string;
  "Cooked By": string;
  "Chosen By": string;
  "Date Cooked": string;
  Created: string;
};

export async function getUneatenMeals(): Promise<Meal[]> {
  return (
    await base<MealFields>(AIRTABLE_MEAL_TABLE)
      .select({
        filterByFormula: "AND({Date Cooked} = BLANK(), {Meal Name})",
        sort: [{ field: "Created", direction: "asc" }],
      })
      .all()
  ).map((meal) => {
    const m: Meal = {
      id: meal.id,
      name: meal.fields["Meal Name"],
      whoChoseIt: meal.fields["Chosen By"],
      whoIsMakingIt: meal.fields["Cooked By"],
    };

    // console.log(`${JSON.stringify(meal.fields)}`);
    // console.log(`${JSON.stringify(m)}`);
    return m;
  });
}

export async function markMealAsEaten(
  mealId: string,
  date: Date
): Promise<void> {
  await base<MealFields>(AIRTABLE_MEAL_TABLE).update(mealId, {
    "Date Cooked": moment(date).format("YYYY-MM-DD"),
  });
}

export async function deleteMeal(mealId: string): Promise<void> {
  await base<MealFields>(AIRTABLE_MEAL_TABLE).destroy(mealId);
}
